import { render } from "./Ventajas.vue?vue&type=template&id=db8b2710&scoped=true"
import script from "./Ventajas.vue?vue&type=script&lang=js"
export * from "./Ventajas.vue?vue&type=script&lang=js"

import "./Ventajas.vue?vue&type=style&index=0&id=db8b2710&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8b2710"]])

export default __exports__